import { Divider } from '@mui/material';
import { flow } from 'fp-ts/function';
import { ProfileEditorWrapper } from '../common';
import BasicAccountSettingsSection from './basic-settings';
import ChangePasswordSection from './change-password';
import DeleteAccountSection from './delete-account';
import ManageAccountSection from './manage-account';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PureAccountSettings = function PureAccountSettings(_ref) {
  var basicAccountSettingsSection = _ref.basicAccountSettingsSection,
      changePasswordSection = _ref.changePasswordSection;
  return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
    "data-element": "ProfileEditorWrapper",
    "data-component": "PureAccountSettings",
    "data-source-file": "account-settings.tsx",
    children: [basicAccountSettingsSection, /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-component": "PureAccountSettings",
      "data-source-file": "account-settings.tsx"
    }), changePasswordSection, /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "account-settings.tsx"
    }), /*#__PURE__*/_jsx(ManageAccountSection, {
      "data-element": "ManageAccountSection",
      "data-source-file": "account-settings.tsx"
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "account-settings.tsx"
    }), /*#__PURE__*/_jsx(DeleteAccountSection, {
      "data-element": "DeleteAccountSection",
      "data-source-file": "account-settings.tsx"
    })]
  });
};

var useProps = function useProps(_ref2) {
  var profileId = _ref2.profileId,
      settings = _ref2.settings,
      name = _ref2.name;
  return {
    basicAccountSettingsSection: /*#__PURE__*/_jsx(BasicAccountSettingsSection, {
      profileId: profileId,
      settings: settings,
      name: name
    }),
    changePasswordSection: /*#__PURE__*/_jsx(ChangePasswordSection, {
      name: name
    })
  };
};

export default Object.assign(flow(useProps, PureAccountSettings), {
  displayName: 'AccountSettings'
});